package pro.jayeshseth.animations.itemPlacements.screens.listItemPlacements

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.EaseInOutBounce
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

private const val ITEM_COUNT = 1000000


@Composable
fun TrippyBlinders(modifier: Modifier = Modifier) {
//    val view = LocalView.current
//    val activity = LocalActivity.current
//    val context = LocalContext.current
//    val window = activity?.window
//    val fallbackWindow = (context as Activity).window
//    val controller = WindowInsetsControllerCompat(
//        window ?: fallbackWindow,
//        view
//    )
//    if (!view.isInEditMode) {
//        DisposableEffect(Unit) {
//            controller.systemBarsBehavior =
//                WindowInsetsControllerCompat.BEHAVIOR_SHOW_TRANSIENT_BARS_BY_SWIPE
//            controller.hide(WindowInsetsCompat.Type.systemBars())
//
//            onDispose {
//                controller.systemBarsBehavior = WindowInsetsControllerCompat.BEHAVIOR_DEFAULT
//                controller.show(WindowInsetsCompat.Type.systemBars())
//            }
//        }
//    }

    val lazyListState = rememberLazyListState()
    val animatedSpace by animateDpAsState(
        targetValue = if (lazyListState.isScrollInProgress) 4.dp else 0.dp,
        animationSpec = tween(1200, easing = EaseInOutBounce),
        label = "animated space"
    )
    val animatedPadding by animateDpAsState(
        targetValue = if (lazyListState.isScrollInProgress) 40.dp else 0.dp,
        animationSpec = tween(2800, easing = EaseInOutBounce),
        label = "animated padding"
    )
    val animatedShape by animateDpAsState(
        targetValue = if (lazyListState.isScrollInProgress) 50.dp else 0.dp,
        animationSpec = tween(2800, easing = EaseInOutBounce),
        label = "animated shape"
    )
    LaunchedEffect(Unit) {
        lazyListState.scrollToItem(ITEM_COUNT / 2)
    }

    var isInitialLoad by remember { mutableStateOf(true) }

    // Track when user starts scrolling to disable initial load flag
    LaunchedEffect(lazyListState.isScrollInProgress) {
        if (lazyListState.isScrollInProgress) {
            isInitialLoad = false
        }
    }


    LazyColumn(
        state = lazyListState,
        verticalArrangement = Arrangement.spacedBy(animatedSpace),
        modifier = modifier
            .background(Color.White),
    ) {
        items(ITEM_COUNT) {
            TrippyBlinderItem(
                index = it,
                cardShape = RoundedCornerShape(animatedShape),
                padding = animatedPadding,
                isInitialLoad = isInitialLoad
            )
        }
    }
}

@Composable
private fun TrippyBlinderItem(
    index: Int,
    cardShape: Shape,
    padding: Dp,
    isInitialLoad: Boolean,
    modifier: Modifier = Modifier
) {
    val animatedIndex = rememberUpdatedState(index)
    val animatedPadding = rememberUpdatedState(padding)
    val animatedCardShape = rememberUpdatedState(cardShape)
    val animatedProgress =
        remember(animatedIndex.value) { Animatable(initialValue = 360f) }
//    val context = LocalContext.current
//    val vibrator = ContextCompat.getSystemService(context, Vibrator::class.java)!!

    var hasAnimated by remember { mutableStateOf(false) }

    LaunchedEffect(animatedIndex.value) {
        if (!isInitialLoad || hasAnimated) {
//            if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.Q) {
//                vibrator.vibrate(VibrationEffect.createPredefined(VibrationEffect.EFFECT_TICK))
//            }

            if (hasAnimated) {
                animatedProgress.snapTo(360f)
            }

            animatedProgress.animateTo(
                targetValue = 0f,
                animationSpec = spring(
                    dampingRatio = Spring.DampingRatioHighBouncy,
                    stiffness = Spring.StiffnessVeryLow
                )
            )
            hasAnimated = true
        } else {
            animatedProgress.snapTo(0f)
        }
    }
    Card(
        colors = CardDefaults.cardColors(
            containerColor = Color.Black
        ),
        shape = animatedCardShape.value,
        modifier = modifier
            .padding(horizontal = animatedPadding.value)
            .fillMaxWidth()
            .graphicsLayer {
                shadowElevation = animatedProgress.value
                shape = animatedCardShape.value
                rotationX = animatedProgress.value
            }
    ) { Spacer(Modifier.size(50.dp)) }
}